import type {
  AdminQuest,
  QuestConditionType,
  QuestTargetRole,
} from "common/types/questManagement.type";

export type QuestFormValues = {
  title: string;
  code: string;
  action_type: string;
  condition_type: QuestConditionType;
  target_role: QuestTargetRole;
  target_count?: number;
  reward_xp?: number;
  shouldGrantBadge: boolean;
  reward_badge_id: string;
  description: string;
  is_active: boolean;
  active_start_month: string;
  active_end_month: string;
};

const toBadgeIdValue = (badgeId: AdminQuest["reward_badge_id"]) =>
  badgeId === null || badgeId === undefined ? "" : String(badgeId);

const toMonthValue = (date: string | null | undefined) =>
  date ? date.slice(0, 7) : "";

export const monthStartDate = (month: string) =>
  month ? `${month}-01` : null;

export const monthEndDate = (month: string) => {
  if (!month) return null;
  const [year, monthNumber] = month.split("-").map(Number);
  return new Date(Date.UTC(year, monthNumber, 0)).toISOString().slice(0, 10);
};

export const getQuestFormDefaultValues = ({
  codeSuggestion,
  initialQuest,
  isDefaultHiddenQuest,
}: {
  codeSuggestion: string;
  initialQuest: AdminQuest | null;
  isDefaultHiddenQuest: boolean;
}): QuestFormValues => ({
  title: initialQuest?.title ?? "",
  code: initialQuest?.code ?? codeSuggestion,
  action_type: isDefaultHiddenQuest
    ? (initialQuest?.action_type ?? "transaction_completed")
    : (initialQuest?.action_type ?? "transaction_completed"),
  condition_type: initialQuest?.condition_type ?? "count",
  target_role: initialQuest?.target_role ?? "all",
  target_count: initialQuest?.target_count,
  reward_xp: initialQuest?.reward_xp,
  shouldGrantBadge: Boolean(initialQuest?.reward_badge_id),
  reward_badge_id: toBadgeIdValue(initialQuest?.reward_badge_id),
  description: initialQuest?.description ?? "",
  is_active: initialQuest?.is_active ?? true,
  active_start_month: isDefaultHiddenQuest
    ? ""
    : toMonthValue(initialQuest?.active_start_at),
  active_end_month: isDefaultHiddenQuest
    ? ""
    : toMonthValue(initialQuest?.active_end_at),
});
